<!--
 * @Descripttion: 
 * @Author: juanjuanhui
 * @Date: 2021-12-06 15:48:04
 * @LastEditors: juanjuanhui
 * @LastEditTime: 2022-06-13 14:27:26
-->
<template>
  <div class="map-bottom-info">
    <div class="left-side" v-if="assignWorks">
      <ul class="list">
        <li class="item">
          <p>
            <span class="number">{{ assignWorks.totalAccountNum }}</span
            ><span>人</span>
          </p>
          <p>人员数</p>
        </li>
        <li class="item">
          <p>
            <span class="number">{{ assignWorks.totalMachineNum }}</span
            ><span>台</span>
          </p>
          <p>机具</p>
        </li>
        <li class="item">
          <p>
            <span class="number">{{ assignWorks.totalLandNum }}</span
            ><span>块</span>
          </p>
          <p>地块数量</p>
        </li>
        <li class="item">
          <p>
            <span class="number">{{ assignWorks.totalLandArea }}</span
            ><span>亩</span>
          </p>
          <p>地块面积</p>
        </li>
      </ul>
    </div>
    <div
      class="center-side"
      v-if="
        assignWorks &&
        assignWorks.assignWorkList &&
        assignWorks.assignWorkList.length > 0
      "
    >
      <swiper ref="mySwiper" :options="swiperOptions">
        <swiper-slide v-for="item in assignWorks.assignWorkList" :key="item.id">
          <div class="info">
            <p>{{ item.uptTime }}</p>
            <p>地块：{{ item.landNum }}块</p>
            <p>面积：{{ item.landArea }}亩</p>
            <p>人员：{{ item.accountNum }}人</p>
            <p>机具：{{ item.machineNum }}台</p>
          </div>
        </swiper-slide>
      </swiper>
      <div class="swiper-button-prev" slot="button-prev" @click="swiperNext">
        <i class="iconfont icon-zuofan" style="font-size: 20px"></i>
      </div>
      <div class="swiper-button-next" slot="button-next" @click="swiperPrev">
        <i class="iconfont icon-youfan" style="font-size: 20px"></i>
      </div>
    </div>
    <div
      v-if="mapBottomInfoOptions.hasAssignBtn"
      class="right-side"
      @click="handleAssignWork"
    >
      <i class="iconfont icon-paihuo"></i>
      <p>派活</p>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
export default {
  data() {
    const that = this;
    return {
      swiperOptions: {
        slidesPerView: 7,
        spaceBetween: 10,
        slidesPerGroup: 7,
        loop: true,
        loopFillGroupWithBlank: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        on: {
          click: function () {
            // this 指向的是 swpier 实例，而不是当前的 vue
            let index = this.clickedSlide.dataset.swiperSlideIndex;
            // this.clickedSlide.classList.add("swiper-slide-active");
            that.handleClickSlide(index);
          },
        },
      },
      assignWorks: {}, // 派活地块统计（地图底部信息）
      assignDetail: {}, // 派活信息（地图右侧信息）
    };
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    // 底部信息配置项
    mapBottomInfoOptions: {
      type: Object,
      default: function () {
        return {
          hasMapBottomInfo: false, // 是否有底部信息
          hasAssignBtn: false, // 是否有派活按钮
          orderId: "", // 订单ID
          workTypeId: "", // 作业类型ID
        };
      },
    },
  },
  mounted() {
    this.getAssignWorks();
  },
  methods: {
    /**
     * @descripttion: 获取派活地块统计（地图底部信息）
     * @Author: juanjuanhui
     * @Date: 2021-12-02 19:32:00
     * @param {*}
     */
    getAssignWorks() {
      let { orderId, workTypeId: workType } = this.mapBottomInfoOptions;
      let params = { orderId, workType };
      this.$http.work.getAssignWorks(params).then((res) => {
        this.assignWorks = res.data;
      });
    },
    /**
     * @descripttion: 点击地图底部某一地块
     * @Author: juanjuanhui
     * @Date: 2021-12-02 19:59:15
     * @param {*} index
     */
    handleClickSlide(index) {
      let id = this.assignWorks.assignWorkList[index].id;
      this.$bus.$emit("changeRightInfo", { show: true, name: "assignDetail" });
      this.$bus.$emit("getAssignDetail", { id });
    },
    /**
     * @descripttion: swiper右箭头
     * @Author: juanjuanhui
     * @Date: 2021-12-02 20:02:56
     */
    swiperNext() {
      this.$refs.mySwiper.$swiper.slidePrev();
    },
    /**
     * @descripttion: swiper左箭头
     * @Author: juanjuanhui
     * @Date: 2021-12-02 20:03:13
     */
    swiperPrev() {
      this.$refs.mySwiper.$swiper.slideNext();
    },
    /**
     * @descripttion: 去派活
     * @Author: juanjuanhui
     * @Date: 2021-12-07 15:49:26
     * @param {*}
     */
    handleAssignWork() {
      this.$router.push({
        path: this.mapBottomInfoOptions.assignRouter,
        query: {
          orderId: this.mapBottomInfoOptions.orderId,
          workTypeId: this.mapBottomInfoOptions.workTypeId,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.map-bottom-info {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  height: 160px;
  background-color: rgba($color: #000000, $alpha: 0.75);
  .left-side {
    position: relative;
    width: 196px;
    height: 100%;
    &::after {
      position: absolute;
      top: 50%;
      right: 0;
      transform: translateY(-50%);
      content: "";
      width: 1px;
      height: 130px;
      background-color: #2c2c2c;
    }
    .list {
      display: flex;
      flex-wrap: wrap;
      height: 100%;
      padding: 15px 0;
      box-sizing: border-box;
      .item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 50%;
        height: 50%;
        padding: 0 10px;
        font-size: 14px;
        color: #ffffff;
        text-align: center;
        box-sizing: border-box;
        .number {
          font-size: 28px;
          color: #018388;
        }
      }
    }
  }
  .center-side {
    position: relative;
    flex: 1;
    width: 0;
    margin: 0 40px;
    box-sizing: border-box;
    .swiper-container {
      overflow: hidden;
      .swiper-slide {
        background-color: rgba($color: #018388, $alpha: 0.2);
        &.swiper-slide-active {
          background-color: #018388;
        }
        .info {
          height: 130px;
          padding: 13px;
          color: #fff;
          font-size: 14px;
          line-height: 22px;
          cursor: pointer;
          box-sizing: border-box;
          p {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
    .swiper-button-prev {
      left: -33px;
      color: #fff;
      &::after {
        content: "";
      }
    }
    .swiper-button-next {
      right: -33px;
      color: #fff;
      &::after {
        content: "";
      }
    }
  }
  .right-side {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 55px;
    color: #018388;
    font-size: 20px;
    font-weight: 900;
    cursor: pointer;
    .iconfont {
      font-size: 54px;
      margin-bottom: 3px;
    }
  }
}
</style>
